export default __webpack_public_path__ + "static/media/zenodo-upload.06035118.png";